import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {setLanguage} from '../actions';

const availableLanguages = [
  [ 'de', 'Deutsch' ],
  [ 'en', 'English' ],
  [ 'fr', 'Français' ],
  [ 'es', 'Español' ],
  [ 'it', 'Italiano' ]
];

const mapStateToProps = ({config}) => ({
  currentLanguage: config.language
});

const LanguageSelect = ({currentLanguage, dispatch}) => {
  let select;
  const options = availableLanguages.map(el => (
    <option key={el[0]} value={el[0]}>
      {el[1]}
    </option>
  ));

  return (
    <div className="input-group language-select">
      <span className="input-group-text">
        <span className="halflings halflings-globe" aria-hidden="true"></span>
        <span className="sr-only">Sprache ändern</span>
      </span>

      <select
        className="form-select custom-select"
        ref={n => select = n}
        value={currentLanguage}
        onChange={() => {
          dispatch(setLanguage(select.value));
        }}>
        {options}
      </select>
    </div>
  );
};

LanguageSelect.propTypes = {
  currentLanguage: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(LanguageSelect)
